module.exports = __webpack_public_path__ + "static/media/sonomeazul.3244bb68.png";